'use client';

import { Suspense } from 'react';
import { SessionProvider } from 'next-auth/react';

import { CloudPaymentsPaymentReturnHandler } from '@/features/cloudpayments/components/CloudPaymentsPaymentReturnHandler';
import { NotificationsProvider } from '@/features/notifications/notifications-provider';
import { ThemeProvider } from './theme-provider';
import { Toaster } from './ui/sonner';
import { Toaster as RadixToaster } from './ui/toaster';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      refetchInterval={5 * 60} // Обновляем сессию каждые 5 минут
      refetchOnWindowFocus={true} // Обновляем при фокусе окна
      refetchWhenOffline={false} // Не обновляем когда офлайн
    >
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
        <NotificationsProvider>
          {children}
          <Suspense fallback={null}>
            <CloudPaymentsPaymentReturnHandler />
          </Suspense>
          <Toaster />
          <RadixToaster />
        </NotificationsProvider>
      </ThemeProvider>
    </SessionProvider>
  );
}
